import EventModal from '@/components/Calendar/EventModal/EventModal';
import type { PersonsMap } from '@/hooks/usePersonsMap';
import { useTaskCard } from '@/store/tasks/task-card.queries';
import type { TaskStatus } from '@/store/tasks/tasks.dto';
import { useTasks } from '@/store/tasks/tasks.store';

const SingleTaskModal = ({
  id,
  onClose,
  personsMap,
  statusOptions,
  vendors,
}: {
  id: string;
  onClose(): void;
  personsMap: PersonsMap;
  /** Passed straight to EventModal — the maintenance surfaces cut it to To do / Done. */
  statusOptions?: readonly TaskStatus[];
  vendors?: { name: string; comment: string | null; status: string | null }[];
}) => {
  /**
   * The card waits for everything it shows: each section that arrived on its own after
   * opening grew the modal under the pointer. `useTaskCard` caches it per task, so a
   * card seen before opens at once.
   */
  const card = useTaskCard(id);

  // The store's copy wins once it holds this task: the card's own writes (a status, a
  // file, a participant) land there first. Until the sync lands, the query's copy.
  const storeTask = useTasks((state) => state.currentTask);
  const task = storeTask?.id === id ? storeTask : card.task;

  if (!task || !card.ready) {
    return null;
  }

  return (
    <EventModal
      event={{
        id: task.id,
        title: task.title,
        start: new Date(task.time_slot.start),
        end: new Date(task.time_slot.end),
        extendedProps: task,
      }}
      isModalOpen
      handleCloseModal={onClose}
      personsMap={personsMap}
      quotes={card.quotes}
      invoices={card.invoices}
      bids={card.bids}
      commentsPreloaded
      statusOptions={statusOptions}
      vendors={vendors}
    />
  );
};

export default SingleTaskModal;
